import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_INSURANCE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemRefundInsuranceMaybe = props => {
  const { lineItems, intl, isProvider } = props;

  const refund = lineItems.find(item => item.code === LINE_ITEM_INSURANCE && item.reversal);

  return refund
    ? isProvider === false && (
        <div className={css.lineItem}>
          <span className={css.itemLabel}>
            <FormattedMessage id="OrderBreakdown.refundInsurance" />
          </span>
          <span className={css.itemValue}>{formatMoney(intl, refund.lineTotal)}</span>
        </div>
      )
    : null;
};

LineItemRefundInsuranceMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemRefundInsuranceMaybe;
